import { ConnectorStatus } from './../../../_objects/connector';
import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConnectorService } from '../../../_services/http-api/connector.service';
import { CommonSnackBarService } from '../../../_services/common-snack-bar.service';
import { SpinnerService } from '../../../_services/spinner.service';
import { environment } from '../../../../environments/environment';
import { CheckboxComponent } from '@evc/web-components';
import { NetworkStatusService } from '../../../_services/network-status.service';

@Component({
  selector: 'app-settings-connector',
  standalone: true,
  imports: [CommonModule, TranslateModule, CheckboxComponent],
  templateUrl: './settings-connector.component.html',
  styleUrl: './settings-connector.component.scss'
})
export class SettingsConnectorComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject<void>();

  isLoading = signal<boolean>(false);
  connectors = signal<Record<string, ConnectorStatus>>({});

  constructor(
    private connectorService: ConnectorService,
    private snackbar: CommonSnackBarService,
    private oscSpinnerService: SpinnerService,
    private networkStatusService: NetworkStatusService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    if (!this.isOffline) {
      this.checkConnectorsStatus();
    }
  }

  get isOffline() {
    return this.networkStatusService.isOffline;
  }

  private updateConnectorStatus(connectorName: string, connectorStatus: ConnectorStatus) {
    this.connectors.update(current => ({
      ...current,
      [connectorName]: connectorStatus
    }));
  }

  private checkConnectorsStatus() {
    Object
      .entries(environment.CONNECTORS)
      .forEach(([connectorName, connectorId]: [string, string]) => {
        this.connectorService.getConnectorStatus(connectorId).subscribe({
          next: (connectorStatus: ConnectorStatus) => {
            this.updateConnectorStatus(connectorName, connectorStatus);
          },
          error: (error) => {
            console.warn(error);
            this.updateConnectorStatus(connectorName, {
              connectorId,
              connectorName,
              isEnabled: false
            });
          }
        });
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onToggleChange(connectorStatus: ConnectorStatus): void {
    connectorStatus.isEnabled = !connectorStatus.isEnabled;

    this.isLoading.set(true);
    this.oscSpinnerService.show();

    this.connectorService.toggleConnector(connectorStatus)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: () => {
          this.updateConnectorStatus(connectorStatus.connectorName, connectorStatus);

          this.snackbar.open(this.translate.instant('connector.successMessage'));
          this.oscSpinnerService.hide();
          this.isLoading.set(false);
        },
        error: (error) => {
          console.error('Error toggling connector:', error);
          this.snackbar.open(this.translate.instant('connector.errorMessage'));
          this.oscSpinnerService.hide();
          this.isLoading.set(false);
        }
      });
  }
}
